import { baseService } from "cortex/ui/src/service/base";

export const deviceResourcesService = {
  load(deviceId: string, type: string = "all", hours: number = 1) {
    return baseService.get(
      `/api/device/resources/${deviceId}?type=${type}&hours=${hours}`,
    );
  },
};

export default deviceResourcesService;
